import { FunctionComponent } from 'react';
import { useRouter } from 'next/router';

// Components
import Image from '@Components/Utils/Image';

// Utilities
import classnames from 'classnames';
import { getUrl } from '@Libs/utils';

// Styles
import styles from './Notification.module.scss';
import notificationApi from '@Libs/api/user/notification';

// Contexts
import { useHttpContext } from '@Libs/http';
import { useAppStore } from '@Components/AppStore/Context';

interface NotificationProps {
    id: string;
    data?: any;
    icon?: string;
    text?: string;
    type?: string;
    title?: string;
    isRead?: boolean;
    className?: string;
    idTypeNotification?: string;
}

const NOTIFICATION_TITLE = {
    new_service_booking: 'Lịch hẹn được xác nhận',
    service_booking_updated: 'Lịch đặt hẹn cập nhật',
    service_booking_finished: 'Đặt lịch hẹn thành công',
    service_booking_telemedicine_new: 'Lịch đặt hẹn mới',
    service_booking_telemedicine_updated: 'Lịch hẹn có cập nhật',
    service_booking_canceled: 'Lịch hẹn của người dùng đã bị hủy',
    service_booking_telemedicine_remind: 'Lịch hẹn được nhắc lại',
    service_booking_telemedicine_canceled: 'Lịch hẹn tư vấn bị từ chối',
    service_booking_telemedicine_processing: 'Lịch hẹn được xác nhận',
    service_booking_processing: 'Lịch đặt hẹn của người dùng đã được xác nhận và đang được xử lý',
};

const getServiceBookingPath = ({ serviceBookingId }) => getUrl(`/dat-hen/${serviceBookingId}/chi-tiet.html`);

const getNotificationConfig = (type) => {
    if (type.match(/service_booking/)) {
        switch (type) {
            case 'service_booking_canceled':
            case 'service_booking_telemedicine_canceled':
                return { icon: '/assets/navbar/menu/schedule_fail.png', path: getServiceBookingPath };

            default:
                return { icon: '/assets/navbar/menu/schedule.png', path: getServiceBookingPath };
        }
    }

    if (type.match(/question/)) {
        return { icon: '/assets/notification/question.png', path: ({ questionId }) => getUrl(`/hoi-dap/${questionId}/chi-tiet.html`) };
    }
    if (type.match(/promo/)) {
        return { icon: '/assets/notification/promo.png' };
    }
    if (type.match(/article/)) {
        return { icon: '/assets/notification/post.png' };
    }

    return { icon: '/assets/navbar/menu/alert.png', path: null, typeId: null };
};

const Notification: FunctionComponent<NotificationProps> = ({ id, icon, text, type, title, className, isRead, idTypeNotification }) => {
    const router = useRouter();
    const { userHttp } = useHttpContext();
    const { updateCountNotification } = useAppStore();

    const classNameItem = classnames([
        styles.wrapper,
        {
            [styles.read]: !!isRead,
        },
        className,
    ]);

    const { icon: notificationIcon = icon } = getNotificationConfig(type);
    const notificationTitle = title || NOTIFICATION_TITLE[type] || 'Thông báo';

    const handleMarkRead = async () => {
        await notificationApi(userHttp).postMarkReadNotification(id, {
            isNotificationId: false,
        });

        updateCountNotification();

        if (type.match(/article/) && idTypeNotification) {
            router.push(`/bai-viet/${idTypeNotification}`);
        }
        // if (path) {
        //     router.push(path(data));
        // }
    };

    return (
        <div onClick={handleMarkRead} className={classNameItem}>
            <Image width={'48px'} height={'48px'} src={notificationIcon} className={styles.icon} />

            <div className={styles.content}>
                <h4 className={styles.title}>{notificationTitle}</h4>
                <div className={styles.text}>{text}</div>
            </div>
        </div>
    );
};

Notification.defaultProps = {
    id: '',
    icon: '',
    isRead: false,
    idTypeNotification: '',
};

export default Notification;
